import { type ButtonProps, AddRoundedIcon, Button } from '@shared/components';

export default function AddNewLevelItemButton(props: Readonly<ButtonProps>) {
  const { sx, onClick, ...restProps } = props;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onClick?.(event);
  };

  return (
    <Button
      size='small'
      variant='outlined'
      startIcon={<AddRoundedIcon />}
      sx={{
        justifyContent: 'flex-start',
        alignSelf: 'center',
        borderColor: (theme) => theme.palette.primary.main,
        ...sx,
      }}
      color='secondary'
      onClick={handleClick}
      {...restProps}
    />
  );
}
